export const simpleSort = (a: any, b: any) => a > b ? 1 : -1